/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import { sortAlphaObj } from '../../lib/helpers';
import AUCollapsibleComponent from '../AUCollapsibleComponent';

class DataBoxAssociationComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props.open,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const {
      rememberState,
      boxID,
      grouping,
      index,
    } = this.props;
    const { open } = this.state;
    if (rememberState) {
      if (open) {
        sessionStorage.removeItem(`box-${boxID}-group-${grouping}-index-${index}`);
      } else {
        sessionStorage.setItem(`box-${boxID}-group-${grouping}-index-${index}`, true);
      }
    }
    this.setState((prevState) => ({
      open: !prevState.open,
    }));
  }

  render() {
    const { open } = this.state;
    const { assoc } = this.props;
    const { items } = assoc;
    const renderItems = items.sort(sortAlphaObj).map((item) => {
      if (item.children.length > 0) {
        const renderChildren = item.children.sort(sortAlphaObj).map((c) => (
          <li key={c.id}>
            <a href={c.url}>
              {c.name}
            </a>
          </li>
        ));

        return (
          <li key={item.id}>
            {(() => {
              if (!item.url) {
                return (
                  <span>
                    {item.name}
                  </span>
                );
              }
              return (
                <a href={item.url}>
                  {item.name}
                </a>
              );
            })()}
            <ul>
              {renderChildren}
            </ul>
          </li>
        );
      }

      return (
        <li key={item.id}>
          <a href={item.url}>
            {item.name}
          </a>
        </li>
      );
    });

    const content = (
      <ul>
        {renderItems}
      </ul>
    );

    return (
      <AUCollapsibleComponent
        key={open}
        collapsed={!open}
        level={3}
        header={assoc.name}
        content={content}
        onClick={this.handleClick}
      />
    );
  }
}

DataBoxAssociationComponent.defaultProps = {

};

DataBoxAssociationComponent.propTypes = {
  boxID: PropTypes.number.isRequired,
  grouping: PropTypes.number.isRequired,
  assoc: PropTypes.shape({
    name: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({

    })).isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  rememberState: PropTypes.bool.isRequired,
};

DataBoxAssociationComponent.displayName = 'DataBoxAssociationComponent';
export default DataBoxAssociationComponent;
